import api from './api';
import TokenService from './tokenService';

const register = (username, email, password) => {
    return api.post('/register/', { username, email, password }).then((response) => {
        if (response.data.access) {
            TokenService.setUser(response.data);
        }
        return response.data;
    });
};

const login = (username, password) => {
    return api
        .post('/login/', { username, password })
        .then((response) => {
            if (response.data.access) {
                TokenService.setUser(response.data);
            }

            return response.data;
        });
};

const logout = () => {
    TokenService.removeUser();
};

const getCurrentUser = () => {
    return TokenService.getUser();
};

const requestPasswordReset = (email) => {
    return api.post('/password-reset/request/', { email });
};

const confirmPasswordReset = (token, newPassword, confirmPassword) => {
    return api.post('/password-reset/confirm/', {
        token,
        new_password: newPassword,
        confirm_password: confirmPassword
    });
};

const requestOtp = (email) => {
    return api.post('/customer/request-otp/', { email });
};

const verifyOtp = (email, otpCode) => {
    return api.post('/customer/verify-otp/', { 
        email, 
        otp_code: otpCode 
    }).then((response) => {
        const accessToken = response.data.access || response.data.token;
        if (accessToken) {
            // Store token in user object format for TokenService
            const userData = {
                access: accessToken,
                refresh: response.data.refresh || null,
                email: email,
                expires_at: response.data.expires_at,
                isCustomer: true
            };
            TokenService.setUser(userData);
        }
        return {
            ...response.data,
            access: accessToken,
        };
    });
};

const AuthService = {
    register,
    login,
    logout,
    getCurrentUser,
    requestPasswordReset,
    confirmPasswordReset,
    requestOtp,
    verifyOtp,
};

export default AuthService;